var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.269257,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2498",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.269257,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2498)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.269257,
    width: 22,
    height: 16,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.738392 -1.53316L8.65022 4.91468V-1.06667H13.8883V4.91468L23.2769 -1.53316L24.4486 0.235455L17.0256 5.33333H22.2693V10.6667H17.0256L24.4486 15.7645L23.2769 17.5332L13.8883 11.0853V17.0667H8.65022V11.0853L-0.738392 17.5332L-1.91003 15.7645L5.51292 10.6667H0.269262V5.33333H5.51292L-1.91003 0.235456L-0.738392 -1.53316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.937 5.06575L24.8883 -1.6",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9936 10.958L24.9145 17.0803",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55932 5.04837L-2.74591 -1.33678",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56857 10.8839L-2.74591 17.8484",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.269257 9.6H9.69783V16H12.8407V9.6H22.2693V6.4H12.8407V0H9.69783V6.4H0.269257V9.6Z",
    fill: "#E6273E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.516ce7cb5ad704af05db126b2d238930.svg";
export { ForwardRef as ReactComponent };